export type Asset = {
	id: string;
	derivative?: string;
	bynderId?: string;
}

export type AssetInput = {
	id?: string;
	derivative?: string;
	bynderId?: string;
}

/**
 * Converts an Asset object to an AssetInput object.
 *
 * @param {Asset} asset - The Asset object to convert.
 * @returns {AssetInput} The converted AssetInput object.
 */
export const assetToAssetInput = (asset: Asset): AssetInput => {
	return {
		id: asset.id,
		derivative: asset.derivative,
		bynderId: asset.bynderId,
	};
}